import * as React from "react";
import { styled } from "@mui/system";
import MUIIconButton from "@mui/material/IconButton";
import { IconButtonProps as IconButtonPropsMUI } from "@mui/material/IconButton";
import {
  ExtendButtonBase,
  ExtendButtonBaseTypeMap
} from "@mui/material/ButtonBase";
export interface IconButtonProps extends IconButtonPropsMUI {}

const IconButtonRoot = styled(MUIIconButton, {
  name: "IconButton",
  slot: "Root",
  overridesResolver: (props, styles) => [styles.root]
})(({ theme }) => ({
  svg: {
    fontSize: "16px"
  },
  "&.MuiIconButton-root.MuiIconButton-sizeSmall": {
    maxWidth: 32,
    maxHeight: 32,
    minWidth: 32,
    minHeight: 32
  },
  "&.MuiIconButton-root.MuiIconButton-sizeMedium": {
    maxWidth: 40,
    maxHeight: 40,
    minWidth: 40,
    minHeight: 40
  },
  "&.MuiIconButton-root.MuiIconButton-sizeLarge": {
    padding: 0,
    minWidth: 48,
    minHeight: 48
  }
}));

export type IconButtonTypeMap<
  AdditionalProps = {},
  RootComponent extends React.ElementType = "button"
> = ExtendButtonBaseTypeMap<{
  props: AdditionalProps & IconButtonProps;
  defaultComponent: RootComponent;
}>;

export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  function IconButton(props, ref) {
    return <IconButtonRoot {...props} ref={ref} />;
  }
) as ExtendButtonBase<IconButtonTypeMap<{}, "button">>;
